module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#business",
      toString: function () {
        return this.url;
      }
    }